<template>
  <div class="button-starter btn " v-bind:class="{'btn-primary': !disabled}" @click="clicked"><div class="place inter-medium-white-16px">START</div></div>
</template>

<script>
export default {
  name: "ButtonStarter",
  props: {
    package: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    clicked() {
      this.$emit('start', this.package)
    }
  }
};
</script>

<style scoped>
.button-starter,
.button-starter-1 {
  align-items: center;
  border: 1px solid;
  border-color: var(--chetwode-blue);
  border-radius: 8px;
  display: flex;
  height: 48px;
  margin-right: 2px;
  margin-top: 8px;
  width: 166px;
  cursor: pointer;
}

.place,
.place-1 {
  flex: 1;
  height: 24px;
  letter-spacing: -0.25px;
  line-height: 24px;
  margin-left: 34.73%;
  margin-right: 34.73%;
  white-space: nowrap;
  width: 50.69px;
}
</style>
